// dependencies
import { fromJS } from "immutable";
import { CreateProcess } from "redux-process";

// utils

// selectors
import { getCurrentEnvironmentName } from "Selectors/app";

export const ClearCustomerBadLogins = CreateProcess({
	method: "DELETE",
	name: "ClearCustomerBadLogins",
	type: "CUSTOMERS:CLEARBADLOGINS",

	request: (props, { getState }) => {
		const state = getState();
		const environment = getCurrentEnvironmentName(state);

		return {
			url: `/${environment}/customers/${props.customerID}/bad-logins/`,
		};
	},

	success: (response) => response.data,
});
